import * as React from "react";
import { Remove, color } from "@conserveit/blocks";
import { $SelectedSite as $SelectedSiteBase } from "./Site.styles";

// Site.styles.js is untyped; declare the style prop it reads.
const $SelectedSite = $SelectedSiteBase as React.ComponentType<
  React.ComponentProps<typeof $SelectedSiteBase> & { noMatch?: boolean }
>;

interface Props {
  label: string;
  onClick: () => void;
  noMatch?: any;
}
const SelectedSite: React.FC<Props> = ({ label, onClick, noMatch }) => (
  <$SelectedSite
    type="button"
    title={label}
    onClick={onClick}
    noMatch={noMatch}
  >
    <span className="Site-label">{label}</span>
    <Remove tiny fillColor={color.theme.icon.default} />
  </$SelectedSite>
);

export default SelectedSite;
